"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("../../../core/button"));
var _modal = _interopRequireDefault(require("../../../core/modal"));
var _input = _interopRequireDefault(require("../../../core/input"));
var _table = _interopRequireDefault(require("../../../core/table"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
var _ref = /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
  rowSpan: "2"
}, "Division"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right",
  rowSpan: "2"
}, "Number of Published Competitions"), /*#__PURE__*/_react.default.createElement("th", {
  colSpan: "2",
  className: "cell-border-left text-xs-center"
}, "Accepted"), /*#__PURE__*/_react.default.createElement("th", {
  colSpan: "2",
  className: "cell-border-left text-xs-center"
}, "Waiting List"), /*#__PURE__*/_react.default.createElement("th", {
  colSpan: "2",
  className: "cell-border-left text-xs-center"
}, "Cancelled")), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
  className: "cell-border-left text-xs-right"
}, "Total"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Entered Online"), /*#__PURE__*/_react.default.createElement("th", {
  className: "cell-border-left text-xs-right"
}, "Total"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Entered Online"), /*#__PURE__*/_react.default.createElement("th", {
  className: "cell-border-left text-xs-right"
}, "Total"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Entered Online")));
var _ref2 = /*#__PURE__*/_react.default.createElement("th", null, "TOTALS");
class EntryStatusSummary extends _react.Component {
  render() {
    const statsByYear = this.props.statsByYear;
    const totals = {
      accepted: 0,
      onlineAccepted: 0,
      waiting: 0,
      onlineWaiting: 0,
      cancelled: 0,
      onlineCancelled: 0
    };
    statsByYear.entryStatusSummary.map(row => {
      totals.accepted += +row.accepted;
      totals.onlineAccepted += +row.onlineAccepted;
      totals.waiting += +row.waiting;
      totals.onlineWaiting += +row.onlineWaiting;
      totals.cancelled += +row.cancelled;
      totals.onlineCancelled += +row.onlineCancelled;
    });
    totals.publishedCompetitions = this.props.competitions.filter(c => c.isPublished && !c.isCancelled).length;
    return /*#__PURE__*/_react.default.createElement(_table.default, null, _ref, /*#__PURE__*/_react.default.createElement("tbody", null, statsByYear.entryStatusSummary.map(row => /*#__PURE__*/_react.default.createElement("tr", {
      key: row.division
    }, /*#__PURE__*/_react.default.createElement("th", null, row.division), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, row.publishedCompetitions), /*#__PURE__*/_react.default.createElement("td", {
      className: "cell-border-left text-xs-right"
    }, row.accepted), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, row.onlineAccepted), /*#__PURE__*/_react.default.createElement("td", {
      className: "cell-border-left text-xs-right"
    }, row.waiting), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, row.onlineWaiting), /*#__PURE__*/_react.default.createElement("td", {
      className: "cell-border-left text-xs-right"
    }, row.cancelled), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, row.onlineCancelled)))), /*#__PURE__*/_react.default.createElement("tfoot", null, /*#__PURE__*/_react.default.createElement("tr", null, _ref2, /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right"
    }, totals.publishedCompetitions), /*#__PURE__*/_react.default.createElement("th", {
      className: "cell-border-left text-xs-right"
    }, totals.accepted), /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right"
    }, totals.onlineAccepted), /*#__PURE__*/_react.default.createElement("th", {
      className: "cell-border-left text-xs-right"
    }, totals.waiting), /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right"
    }, totals.onlineWaiting), /*#__PURE__*/_react.default.createElement("th", {
      className: "cell-border-left text-xs-right"
    }, totals.cancelled), /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right"
    }, totals.onlineCancelled))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref3 = {
  id: true,
  entryStatusSummary: true
};
var _ref4 = {
  id: true,
  isPublished: true,
  isCancelled: true
};
var _default = exports.default = (0, _reactBicycle.connect)(EntryStatusSummary, props => ({
  ["statsByYear(yearID:" + JSON.stringify(+props.yearID) + ")"]: _ref3,
  ["competitions(yearID:" + JSON.stringify(+props.yearID) + ")"]: _ref4
}));